// ===== Force unlock scroll (mobile safe) =====
(function () {
  const CLASS_TOKENS = [
    "no-scroll",
    "scroll-locked",
    "locked",
    "lock-scroll",
    "modal-open",
    "drawer-open",
    "cart-open",
    "overflow-hidden",
    "prevent-scrolling",
    "dropdown-open",
  ];

  function removeTokens(el) {
    if (!el || !el.classList) return;
    CLASS_TOKENS.forEach((c) => el.classList.remove(c));
  }

  window.AO_FORCE_SCROLL_UNLOCK = function () {
    const html = document.documentElement;
    const body = document.body;

    // remove common theme/app classes
    removeTokens(html);
    removeTokens(body);

    // clear inline locks (common iOS patterns included)
    if (body) {
      body.style.overflow = "";
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.touchAction = "";
    }
    if (html) {
      html.style.overflow = "";
      html.style.touchAction = "";
    }

    // restore scroll if a position:fixed + top:-scrollY trick was used
    try {
      const top = body && body.style && body.style.top ? body.style.top : "";
      if (top && top.includes("px")) {
        const n = parseInt(top, 10);
        if (Number.isFinite(n) && n < 0) {
          window.scrollTo(0, Math.abs(n));
        }
      }
    } catch (e) {}
  };

  // iOS bfcache can keep body locked
  window.addEventListener("pageshow", () => {
    if (window.AO_FORCE_SCROLL_UNLOCK) window.AO_FORCE_SCROLL_UNLOCK();
  });
})();

// assets/custom.js
(function () {
  const SELECTOR_CHIP = "[data-plp-quick-add][data-variant-id]";
  const SELECTOR_QUICK_CART = ".quick-cart[data-section-id]";
  const SELECTOR_CART_COUNT = "[data-cart-count], [data-js-cart-count]";

  // Notify-me modal selectors (as per your HTML)
  const NOTIFY_MODAL_WRAPPER = ".restock-alerts-modal-wrapper";
  const NOTIFY_VARIANT_SELECT = "select.restock-alerts-variant-select";

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }

  async function postJSON(url, payload) {
    const res = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    return res.json();
  }

  async function getJSON(url) {
    const res = await fetch(url, { method: "GET", credentials: "include" });
    return res.json();
  }

  async function getText(url) {
    const res = await fetch(url, { method: "GET", credentials: "include" });
    return res.text();
  }

  function getCartRoutes() {
    const routes = (window.theme && window.theme.routes && window.theme.routes.cart) || {};
    return {
      add: (routes.add || "/cart/add") + ".js",
      cart: (routes.base || "/cart") + ".js",
      base: routes.base || "/cart",
    };
  }

  async function renderSectionById(sectionId) {
    const url = `/?section_id=${encodeURIComponent(sectionId)}`;
    return getText(url);
  }

  async function refreshQuickCartSection() {
    const qc = document.querySelector(SELECTOR_QUICK_CART);
    if (!qc) return false;

    const sectionId = qc.getAttribute("data-section-id");
    if (!sectionId) return false;

    const html = await renderSectionById(sectionId);
    const doc = new DOMParser().parseFromString(html, "text/html");
    const newQc = doc.querySelector(SELECTOR_QUICK_CART);
    if (!newQc) return false;

    qc.innerHTML = newQc.innerHTML;

    [...newQc.attributes].forEach((attr) => qc.setAttribute(attr.name, attr.value));

    updateFreeShippingBar(qc);

    qc.dispatchEvent(
      new CustomEvent("shopify:section:load", {
        bubbles: true,
        detail: { sectionId },
      })
    );
    document.dispatchEvent(new CustomEvent("shopify:section:load", { detail: { sectionId } }));

    // NEW (essential): if cart is not open after refresh, force-unlock (mobile theme locks)
    const wrapper = qc.querySelector(".quick-cart__wrapper");
    const isOpen = wrapper && wrapper.classList.contains("active");
    if (!isOpen && window.AO_FORCE_SCROLL_UNLOCK) window.AO_FORCE_SCROLL_UNLOCK();

    return true;
  }

  async function refreshCartCount() {
    const { cart } = getCartRoutes();
    const data = await getJSON(cart);
    const count = Number(data && data.item_count ? data.item_count : 0);

    document.querySelectorAll(SELECTOR_CART_COUNT).forEach((el) => {
      el.textContent = String(count);
      el.setAttribute("data-cart-count", String(count));
    });

    document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
      const ariaHidden = bubble.querySelector('span[aria-hidden="true"]');
      if (ariaHidden) ariaHidden.textContent = String(count);

      const sr = bubble.querySelector(".visually-hidden");
      if (sr) sr.textContent = `Panier (${count})`;
    });

    const cartTrigger = document.querySelector(
      '[aria-controls*="cart"], [data-cart-drawer-trigger], a[href="/cart"]'
    );
    if (cartTrigger) cartTrigger.setAttribute("aria-label", `Panier (${count})`);

    return data;
  }

  function openQuickCart() {
    const qc = document.querySelector(SELECTOR_QUICK_CART);
    if (!qc) return;

    const wrapper = qc.querySelector(".quick-cart__wrapper");
    if (!wrapper) return;

    wrapper.classList.add("active");
  }

  function closeQuickCart() {
    const qc = document.querySelector(SELECTOR_QUICK_CART);
    if (!qc) return;

    const wrapper = qc.querySelector(".quick-cart__wrapper");
    if (!wrapper) return;

    wrapper.classList.remove("active");

    // NEW (essential): brute-force unlock for mobile/iOS/theme leftovers
    if (window.AO_FORCE_SCROLL_UNLOCK) window.AO_FORCE_SCROLL_UNLOCK();
  }

  document.addEventListener("click", function (e) {
    const cartIcon = e.target.closest('[data-js-cart-icon="bag"]');
    if (!cartIcon) return;

    e.preventDefault();
    openQuickCart();
  });

  function formatMoneyFromCents(cents) {
    const value = cents / 100;
    return (
      value.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " €"
    );
  }

  function updateFreeShippingBar(root) {
    const container = root || document;
    const bar = container.querySelector(".free-shipping-bar[data-free-shipping-bar]");
    if (!bar) return false;

    const threshold = Number(bar.getAttribute("data-threshold") || 0);
    const cartTotalCents = Number(bar.getAttribute("data-cart-total") || 0);

    const msgEl = bar.querySelector(".free-shipping-bar__message");
    const barEl = bar.querySelector(".free-shipping-bar__bar");

    if (!threshold || !Number.isFinite(cartTotalCents) || !barEl) return false;

    const thresholdCents = Math.round(threshold * 100);
    const remainingCents = Math.max(0, thresholdCents - cartTotalCents);

    const isSuccess = cartTotalCents >= thresholdCents;
    const progress = Math.max(0, Math.min(100, (cartTotalCents / thresholdCents) * 100));

    bar.classList.add("free-shipping-bar--loaded");
    bar.classList.toggle("free-shipping-bar--success", isSuccess);

    barEl.style.setProperty("--progress-width", isSuccess ? "100%" : `${progress.toFixed(2)}%`);

    const successTpl = bar.getAttribute("data-free-shipping-success-message") || "";
    const pendingTpl = bar.getAttribute("data-free-shipping-pending-message") || "";

    if (msgEl) {
      if (isSuccess) {
        msgEl.textContent = successTpl;
      } else {
        const remaining = formatMoneyFromCents(remainingCents);
        msgEl.textContent = pendingTpl.replace("{{ remaining_amount }}", remaining);
      }
    }

    return true;
  }

  async function addVariantToCart(variantId, quantity) {
    const { add } = getCartRoutes();

    dispatch("cart:updating");

    const addRes = await postJSON(add, {
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
    });

    if (addRes && addRes.status === 422) {
      dispatch("cart:error", { error: addRes });
      dispatch("quick-cart:error", { error: addRes });
      return { ok: false, error: addRes };
    }

    await refreshQuickCartSection();
    const cartData = await refreshCartCount();

    dispatch("cart:updated", { cart: cartData });
    dispatch("quick-cart:updated", { cart: cartData });

    return { ok: true, cart: cartData };
  }

  async function changeLineItem(lineKeyOrId, quantity) {
    return postJSON("/cart/change.js", { id: lineKeyOrId, quantity });
  }

  /* =========================================================
     NEW: helpers to ensure correct color/product for PLP ATC
  ========================================================= */

  async function fetchProductByHandle(handle) {
    if (!handle) return null;
    try {
      const res = await fetch(`/products/${handle}.js`, { credentials: "include" });
      if (!res.ok) return null;
      return await res.json();
    } catch {
      return null;
    }
  }

  function normalize(str) {
    return String(str || "").trim().toLowerCase();
  }

  function getSizeValueFromChip(el) {
    const ds = el.getAttribute("data-size") || el.dataset.size;
    if (ds) return ds;

    const txt = el.textContent;
    return txt ? txt.trim() : "";
  }

  function findVariantIdBySize(product, sizeValue) {
    if (!product || !Array.isArray(product.variants) || !sizeValue) return null;

    const target = normalize(sizeValue);
    const v = product.variants.find((variant) => {
      if (Array.isArray(variant.options)) {
        return variant.options.some((opt) => normalize(opt) === target);
      }
      return [variant.option1, variant.option2, variant.option3].some(
        (opt) => normalize(opt) === target
      );
    });

    return v ? v.id : null;
  }

  async function getSelectedProductForCard(card) {
    if (!card) return null;

    if (card.__aoSelectedProduct) return card.__aoSelectedProduct;

    const selectedHandle = card.dataset.aoSelectedHandle;
    if (selectedHandle) {
      const p = await fetchProductByHandle(selectedHandle);
      if (p) {
        card.__aoSelectedProduct = p;
        return p;
      }
    }

    return null;
  }

  /* =========================================================
     NEW: Notify-me (restock) modal opener on disabled chip click
  ========================================================= */

  function waitForElement(selector, timeoutMs = 2000) {
    return new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) return resolve(el);

      const obs = new MutationObserver(() => {
        const found = document.querySelector(selector);
        if (found) {
          obs.disconnect();
          resolve(found);
        }
      });

      obs.observe(document.documentElement, { childList: true, subtree: true });

      window.setTimeout(() => {
        obs.disconnect();
        resolve(null);
      }, timeoutMs);
    });
  }

  function openNotifyMeModal(wrapper) {
    if (!wrapper) return false;

    wrapper.style.display = "block";
    wrapper.style.visibility = "visible";

    const box = wrapper.querySelector(".restock-alerts-modal-box");
    if (box) {
      box.style.pointerEvents = "auto";
      box.style.opacity = "1";
    }
    return true;
  }

  function setNotifyMeVariant(wrapper, variantId) {
    if (!wrapper || !variantId) return false;

    const select = wrapper.querySelector(NOTIFY_VARIANT_SELECT);
    if (!select) return false;

    const hasOption = Array.from(select.options).some(
      (opt) => String(opt.value) === String(variantId)
    );
    if (!hasOption) return false;

    select.value = String(variantId);
    select.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  async function openNotifyMeForVariant(variantId) {
    let wrapper = document.querySelector(NOTIFY_MODAL_WRAPPER);
    if (!wrapper) wrapper = await waitForElement(NOTIFY_MODAL_WRAPPER, 2000);
    if (!wrapper) return false;

    openNotifyMeModal(wrapper);
    setNotifyMeVariant(wrapper, variantId);
    return true;
  }

  /* ===============================
     CLICK HANDLERS (delegation)
  =============================== */

  // 1) PLP chip quick add + open notify-me on disabled chip
  document.addEventListener("click", async function (e) {
    const link = e.target.closest(SELECTOR_CHIP);
    if (!link) return;

    const isDisabled =
      link.getAttribute("aria-disabled") === "true" || link.classList.contains("is-disabled");

    if (isDisabled) {
      e.preventDefault();
      e.stopPropagation();

      const card = link.closest(".product-item");
      const selectedProduct = await getSelectedProductForCard(card);

      const sizeValue = getSizeValueFromChip(link);

      let variantIdToNotify = link.getAttribute("data-variant-id");

      if (selectedProduct) {
        const selectedVariantId = findVariantIdBySize(selectedProduct, sizeValue);
        if (selectedVariantId) variantIdToNotify = String(selectedVariantId);
      }

      await openNotifyMeForVariant(variantIdToNotify);
      return;
    }

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const variantIdFromChip = link.getAttribute("data-variant-id");

    const card = link.closest(".product-item");
    const selectedProduct = await getSelectedProductForCard(card);

    let variantIdToAdd = variantIdFromChip;

    if (selectedProduct) {
      const sizeValue = getSizeValueFromChip(link);
      const selectedVariantId = findVariantIdBySize(selectedProduct, sizeValue);
      if (selectedVariantId) variantIdToAdd = String(selectedVariantId);
    }

    if (!variantIdToAdd) return;

    e.preventDefault();

    link.classList.add("is-loading");
    const result = await addVariantToCart(variantIdToAdd, 1);
    link.classList.remove("is-loading");

    if (!result.ok) return;

    if (window.location.pathname === "/cart") {
      window.location.reload();
      return;
    }

    const hasConfirmation = document.querySelector(".purchase-confirmation-popup");
    if (hasConfirmation) {
      dispatch("confirmation-popup:open");
      return;
    }

    openQuickCart();
  });

  // 2) Close quick cart (button + overlay) - click
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-modal-close]") || e.target.closest(".quick-cart__overlay")) {
      e.preventDefault();
      closeQuickCart();
    }
  });

  // NEW (essential): Close quick cart (button + overlay) - pointerdown (mobile reliability)
  document.addEventListener(
    "pointerdown",
    function (e) {
      if (e.target.closest("[data-modal-close]") || e.target.closest(".quick-cart__overlay")) {
        e.preventDefault();
        closeQuickCart();
      }
    },
    { passive: false }
  );

  // 3) Remove item (instant refresh)
  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("[data-remove-item]");
    if (!btn) return;

    const item = btn.closest(".quick-cart__item");
    if (!item) return;

    const key = item.getAttribute("data-key") || item.getAttribute("data-id");
    if (!key) return;

    e.preventDefault();

    btn.setAttribute("aria-busy", "true");
    btn.classList.add("is-loading");

    const res = await changeLineItem(key, 0);

    btn.removeAttribute("aria-busy");
    btn.classList.remove("is-loading");

    if (res && res.status === 422) {
      dispatch("cart:error", { error: res });
      dispatch("quick-cart:error", { error: res });
      return;
    }

    await refreshQuickCartSection();
    const cartData = await refreshCartCount();

    dispatch("cart:updated", { cart: cartData });
    dispatch("quick-cart:updated", { cart: cartData });

    openQuickCart();
  });

  // 4) Quantity +/- (instant refresh)
  document.addEventListener("click", async function (e) {
    const plusBtn = e.target.closest("[data-add-quantity]");
    const minusBtn = e.target.closest("[data-subtract-quantity]");
    if (!plusBtn && !minusBtn) return;

    const btn = plusBtn || minusBtn;

    const item = btn.closest(".quick-cart__item");
    if (!item) return;

    const key = item.getAttribute("data-key") || item.getAttribute("data-id");
    if (!key) return;

    const input = item.querySelector("[data-quantity-input]");
    if (!input) return;

    e.preventDefault();

    const currentQty = Math.max(1, parseInt(input.value, 10) || 1);
    const nextQty = plusBtn ? currentQty + 1 : Math.max(1, currentQty - 1);

    input.value = String(nextQty);
    btn.setAttribute("aria-busy", "true");

    const res = await changeLineItem(key, nextQty);

    btn.removeAttribute("aria-busy");

    if (res && res.status === 422) {
      dispatch("cart:error", { error: res });
      dispatch("quick-cart:error", { error: res });
      input.value = String(currentQty);
      return;
    }

    await refreshQuickCartSection();
    const cartData = await refreshCartCount();
    dispatch("cart:updated", { cart: cartData });
    dispatch("quick-cart:updated", { cart: cartData });

    openQuickCart();
  });

  // 5) Quantity manual input (debounced)
  let qtyTimer = null;
  document.addEventListener("input", function (e) {
    const input = e.target.closest("[data-quantity-input]");
    if (!input) return;

    const item = input.closest(".quick-cart__item");
    if (!item) return;

    if (qtyTimer) window.clearTimeout(qtyTimer);

    qtyTimer = window.setTimeout(async () => {
      const key = item.getAttribute("data-key") || item.getAttribute("data-id");
      if (!key) return;

      const raw = parseInt(input.value, 10);
      const nextQty = Number.isFinite(raw) ? Math.max(1, raw) : 1;

      input.value = String(nextQty);

      const res = await changeLineItem(key, nextQty);

      if (res && res.status === 422) {
        dispatch("cart:error", { error: res });
        dispatch("quick-cart:error", { error: res });
        return;
      }

      await refreshQuickCartSection();
      const cartData = await refreshCartCount();
      dispatch("cart:updated", { cart: cartData });
      dispatch("quick-cart:updated", { cart: cartData });

      openQuickCart();
    }, 350);
  });

  // 6) Quick view: switch product when a "color" (linked product) is clicked
  document.addEventListener("click", function (e) {
    const link = e.target.closest("#ao-productsgroup a[data-product-url]");
    if (!link) return;

    const quickViewRoot = link.closest('[data-is-quick-view="true"], [data-is-quick-view=true]');
    if (!quickViewRoot) return;

    const productUrl = link.getAttribute("data-product-url") || link.getAttribute("href");
    if (!productUrl) return;

    e.preventDefault();
    e.stopPropagation();

    if (typeof r$1 === "function") {
      r$1("quick-view:refresh", null, { productUrl: productUrl });
      return;
    }

    window.location.assign(productUrl);
  });
})();

(function () {
  // Helpers
  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }
  function qsa(root, sel) {
    return root ? Array.from(root.querySelectorAll(sel)) : [];
  }

  // --- Cart cache
  const _btlCartCache = { ts: 0, promise: null };

  function fetchCartCached() {
    const now = Date.now();
    if (_btlCartCache.promise && now - _btlCartCache.ts < 800) return _btlCartCache.promise;

    _btlCartCache.ts = now;
    _btlCartCache.promise = fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((r) => {
        if (!r.ok) throw new Error("cart");
        return r.json();
      })
      .catch(() => null);

    return _btlCartCache.promise;
  }

  function buildCartQtyByVariant(cart) {
    const map = {};
    if (!cart || !Array.isArray(cart.items)) return map;
    cart.items.forEach((it) => {
      if (it && typeof it.variant_id === "number") {
        map[it.variant_id] = (map[it.variant_id] || 0) + (Number(it.quantity) || 0);
      }
    });
    return map;
  }

  // --- Cart AJAX
  async function addItems(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      let err = null;
      try {
        err = await res.json();
      } catch (e) {}
      const msg =
        err && (err.description || err.message)
          ? err.description || err.message
          : "Erreur ajout panier";
      document.dispatchEvent(new CustomEvent("cart:error", { detail: { errorMessage: msg } }));
      throw new Error(msg);
    }

    const cartRes = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    const cart = await cartRes.json();

    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
    document.dispatchEvent(new CustomEvent("cart:item-added", { detail: { items } }));

    // refresh cache immediately
    _btlCartCache.ts = Date.now();
    _btlCartCache.promise = Promise.resolve(cart);

    return cart;
  }

  // --- UI refresh (counter + quick cart + free shipping) ---------------------

  function refreshHeaderCartCount(cart) {
    if (!cart) return;

    const count = Number(cart.item_count || 0);

    document.querySelectorAll("[data-js-cart-count]").forEach((el) => {
      el.textContent = String(count);
      el.setAttribute("data-cart-count", String(count));
      el.dataset.cartCount = String(count);
    });

    const bagLink = document.querySelector('[data-js-cart-icon="bag"]');
    if (bagLink) {
      bagLink.setAttribute("aria-label", `Panier (${count})`);
    }
  }

async function refreshQuickCartSection() {
  const qc = document.querySelector(SELECTOR_QUICK_CART);
  if (!qc) return false;

  const currentWrapper = qc.querySelector(".quick-cart__wrapper");
  const wasOpen = !!(currentWrapper && currentWrapper.classList.contains("active"));

  const sectionId = qc.getAttribute("data-section-id");
  if (!sectionId) return false;

  const html = await renderSectionById(sectionId);
  const doc = new DOMParser().parseFromString(html, "text/html");
  const newQc = doc.querySelector(SELECTOR_QUICK_CART);
  if (!newQc) return false;

  qc.innerHTML = newQc.innerHTML;

  [...newQc.attributes].forEach((attr) => qc.setAttribute(attr.name, attr.value));

  if (wasOpen) {
    const newWrapper = qc.querySelector(".quick-cart__wrapper");
    if (newWrapper) newWrapper.classList.add("active");
  }

  updateFreeShippingBar(qc);

  qc.dispatchEvent(
    new CustomEvent("shopify:section:load", {
      bubbles: true,
      detail: { sectionId },
    })
  );
  document.dispatchEvent(new CustomEvent("shopify:section:load", { detail: { sectionId } }));

  const wrapper = qc.querySelector(".quick-cart__wrapper");
  const isOpen = wrapper && wrapper.classList.contains("active");
  if (!isOpen && window.AO_FORCE_SCROLL_UNLOCK) window.AO_FORCE_SCROLL_UNLOCK();

  return true;
}

  function refreshFreeShippingBarsFromCart(cart) {
    if (!cart) return;

    const totalCents = Number(cart.total_price || 0);

    document.querySelectorAll("[data-free-shipping-bar]").forEach((bar) => {
      const thresholdVal = bar.getAttribute("data-threshold");
      const t = Number(thresholdVal || 0);

      // robuste: euros ou centimes
      const thresholdCents = t <= 5000 ? Math.round(t * 100) : Math.round(t);

      const msgSuccess = bar.getAttribute("data-free-shipping-success-message") || "";

      const msgPendingTpl = bar.getAttribute("data-free-shipping-pending-message") || "";

      const remainingCents = Math.max(0, thresholdCents - totalCents);
      const isSuccess = remainingCents === 0;

      const remainingEuros = (remainingCents / 100).toFixed(2).replace(".", ",") + " €";

      const msgEl = bar.querySelector(".free-shipping-bar__message");
      if (msgEl) {
        msgEl.textContent = isSuccess
          ? msgSuccess
          : msgPendingTpl.replace("{{ remaining_amount }}", remainingEuros);
      }

      const progress =
        thresholdCents > 0 ? Math.min(100, (totalCents / thresholdCents) * 100) : 0;

      bar.style.setProperty("--progress-width", `${progress}%`);
      bar.setAttribute("data-cart-total", String(totalCents));

      bar.classList.toggle("free-shipping-bar--success", isSuccess);
      bar.classList.add("free-shipping-bar--loaded");
    });
  }

  async function refreshCartUI(cart) {
    refreshHeaderCartCount(cart);
    await refreshQuickCartSection();
    refreshFreeShippingBarsFromCart(cart);
  }

  // --- Drawer open/close
  function lockScroll() {
    document.body.style.overflow = "hidden";
  }
  function unlockScroll() {
    document.body.style.overflow = "";

    // NEW (essential): brute-force unlock for mobile/iOS/theme leftovers
    if (window.AO_FORCE_SCROLL_UNLOCK) window.AO_FORCE_SCROLL_UNLOCK();
  }

  // --- Product switch (colors)
  async function fetchProductJson(handle) {
    const res = await fetch(`/products/${handle}.js`, {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) throw new Error("Impossible de charger le produit " + handle);
    return await res.json();
  }

  function detectSizeLabelKey(productJson) {
    const vars = productJson.variants || [];
    const hasOption2 = vars.some((v) => v.option2);
    if (!hasOption2) return "option1";

    const uniq1 = new Set(vars.map((v) => v.option1).filter(Boolean));
    const uniq2 = new Set(vars.map((v) => v.option2).filter(Boolean));
    return uniq2.size >= uniq1.size ? "option2" : "option1";
  }

  function renderSizesIntoItem(itemEl, productJson, sizeLabel) {
    const sizesWrap = qs(itemEl, "[data-btl-sizes]");
    const hidden = qs(itemEl, "[data-btl-variant-select]");
    if (!hidden || !sizesWrap) return;

    const variants = productJson.variants || [];
    const firstAvailable = variants.find((v) => v.available) || variants[0];
    if (!firstAvailable) return;

    hidden.value = String(firstAvailable.id);

    const key = detectSizeLabelKey(productJson);

    sizesWrap.innerHTML = `
      ${sizeLabel ? `<span style="font-weight: 400;">${sizeLabel}</span>` : ""}
      <div class="btl-tailles">
        ${variants
          .map((v) => {
            const label = (v[key] || v.option1 || v.title || "").trim();
            const disabled = v.available ? "" : "disabled";
            const selected = v.id === firstAvailable.id ? " is-selected" : "";
            return `
            <button type="button"
              class="btl-size${selected}"
              data-btl-size
              data-variant-id="${v.id}"
              ${disabled}
            >${label}</button>
          `;
          })
          .join("")}
      </div>
    `;
  }

  // --- Slider scroll-snap controls
  function initSliderInItem(itemEl) {
    const slider = qs(itemEl, "[data-btl-slider]");
    if (!slider) return;

    const track = qs(slider, "[data-btl-track]");
    const prev = qs(slider, "[data-btl-prev]");
    const next = qs(slider, "[data-btl-next]");
    if (!track || !prev || !next) return;

    function scrollByOne(dir) {
      const slide = qs(track, "[data-btl-slide]");
      const w = slide ? slide.getBoundingClientRect().width : track.getBoundingClientRect().width;
      track.scrollBy({ left: dir * w, behavior: "smooth" });
    }

    prev.onclick = () => scrollByOne(-1);
    next.onclick = () => scrollByOne(1);
  }

  function rebuildSliderSlides(itemEl, productJson) {
    const media = qs(itemEl, "[data-btl-media]");
    if (!media) return;

    const track = qs(media, "[data-btl-track]");
    if (!track) return;

    const url = productJson.url || `/products/${productJson.handle}`;
    const title = (productJson.title || "").replace(/"/g, "&quot;");

    const imgs =
      productJson.images && productJson.images.length ? productJson.images.slice(0, 8) : [];
    const list = imgs.length ? imgs : productJson.featured_image ? [productJson.featured_image] : [];

    track.innerHTML = list
      .map((src) => {
        const safeSrc = src + (src.includes("?") ? "&" : "?") + "width=720";
        return `
        <a class="btl-slider__slide" data-btl-slide href="${url}" aria-label="${title}">
          <img src="${safeSrc}" alt="${title}" loading="lazy" width="360" height="450">
        </a>
      `;
      })
      .join("");

    initSliderInItem(itemEl);
  }

  function setSelectedSwatch(swatchEl) {
    const group = swatchEl.closest(".ao-productsgroup");
    if (!group) return;
    qsa(group, "li.product-pastille").forEach((li) => li.classList.remove("selected"));
    const li = swatchEl.closest("li.product-pastille");
    if (li) li.classList.add("selected");
  }

  // --- SUBMIT button state (label + classes)
  function setSubmitState(itemEl, variantId, isAvailable, inCart) {
    const btn = qs(itemEl, ".btl-item-submit[data-btl-add-one]");
    if (!btn) return;

    const t = window.themeI18n || {};
    const labelAdd = btn.getAttribute("data-label-add") || t.add || "Ajouter";
    const labelSoldout = btn.getAttribute("data-label-soldout") || t.unavailable || "Indisponible";
    const labelInCart = btn.getAttribute("data-label-incart") || t.already_in_cart || "Déjà au panier";

    if (!isAvailable) {
      btn.textContent = labelSoldout;
      btn.disabled = true;
      btn.setAttribute("aria-disabled", "true");
      btn.classList.remove("in-cart", "not-in-cart");
      btn.classList.add("not-in-cart");
      return;
    }

    btn.disabled = false;
    btn.setAttribute("aria-disabled", "false");

    btn.classList.remove("in-cart", "not-in-cart");
    if (inCart) {
      btn.textContent = labelInCart;
      btn.classList.add("in-cart");
    } else {
      btn.textContent = labelAdd;
      btn.classList.add("not-in-cart");
    }

    const hidden = qs(itemEl, "[data-btl-variant-select]");
    if (hidden && variantId) hidden.value = String(variantId);
  }

  async function refreshSubmitFromCurrentSelection(itemEl) {
    const hidden = qs(itemEl, "[data-btl-variant-select]");
    const variantId = hidden ? Number(hidden.value) : null;
    if (!variantId) return;

    const selectedBtn = itemEl.querySelector(`[data-btl-size][data-variant-id="${variantId}"]`);
    const isAvailable = selectedBtn ? !selectedBtn.hasAttribute("disabled") : true;

    const cart = await fetchCartCached();
    const map = buildCartQtyByVariant(cart);
    const inCart = !!(map[variantId] && map[variantId] > 0);

    setSubmitState(itemEl, variantId, isAvailable, inCart);
  }

  async function refreshLookButton(drawer) {
    const btn = qs(drawer, "[data-btl-add-all]");
    if (!btn) return;

    const labelAdd = btn.getAttribute("data-label-add") || "Ajouter le look";
    const labelInCart = btn.getAttribute("data-label-incart") || labelAdd;

    const cart = await fetchCartCached();
    const map = buildCartQtyByVariant(cart);

    const items = qsa(drawer, "[data-btl-item]");
    if (!items.length) return;

    let anyUnavailable = false;
    let allInCart = true;

    for (const itemEl of items) {
      const hidden = qs(itemEl, "[data-btl-variant-select]");
      const variantId = hidden ? Number(hidden.value) : null;
      if (!variantId) {
        allInCart = false;
        continue;
      }

      const selectedBtn = itemEl.querySelector(`[data-btl-size][data-variant-id="${variantId}"]`);
      const isAvailable = selectedBtn ? !selectedBtn.hasAttribute("disabled") : true;

      if (!isAvailable) {
        anyUnavailable = true;
        allInCart = false;
        continue;
      }

      const inCart = !!(map[variantId] && map[variantId] > 0);
      if (!inCart) allInCart = false;
    }

    btn.disabled = !!anyUnavailable;
    btn.setAttribute("aria-disabled", anyUnavailable ? "true" : "false");

    btn.classList.remove("in-cart", "not-in-cart");
    if (allInCart) {
      btn.textContent = labelInCart;
      btn.classList.add("in-cart");
    } else {
      btn.textContent = labelAdd;
      btn.classList.add("not-in-cart");
    }
  }

  function updateItemBasics(itemEl, productJson, handle, drawer) {
    const titleLink = qs(itemEl, ".btl-item__title");
    const href = productJson.url || `/products/${handle}`;

    if (titleLink) {
      titleLink.textContent = productJson.title || "";
      titleLink.href = href;
    }

    const sizesWrap = qs(itemEl, "[data-btl-sizes]");
    const sizeLabelAttr = sizesWrap ? sizesWrap.getAttribute("size-option-name-data") : null;

    let sizeLabel = sizeLabelAttr ? sizeLabelAttr.trim() : "";
    if (!sizeLabel && sizesWrap) {
      const span = qs(sizesWrap, "span");
      if (span) sizeLabel = span.textContent.trim();
    }

    renderSizesIntoItem(itemEl, productJson, sizeLabel);
    rebuildSliderSlides(itemEl, productJson);

    refreshSubmitFromCurrentSelection(itemEl);
    if (drawer) refreshLookButton(drawer);
  }

  function initBTLDrawer(drawer) {
    if (!drawer || drawer.dataset.btlInit === "1") return;
    drawer.dataset.btlInit = "1";

    const drawerId = drawer.id;
    const panel = qs(drawer, ".btl-drawer__panel");
    const closeEls = qsa(drawer, "[data-btl-close]");

    const openBtn =
      document.querySelector(`[aria-controls="${drawerId}"][data-btl-open]`) ||
      document.querySelector(`[aria-controls="${drawerId}"]`);

    let lastFocus = null;

    async function open() {
      lastFocus = document.activeElement;
      drawer.setAttribute("aria-hidden", "false");
      lockScroll();
      if (panel) panel.focus();

      qsa(drawer, "[data-btl-item]").forEach(initSliderInItem);

      const items = qsa(drawer, "[data-btl-item]");
      for (const it of items) {
        await refreshSubmitFromCurrentSelection(it);
      }
      await refreshLookButton(drawer);
    }

    function close() {
      drawer.setAttribute("aria-hidden", "true");
      unlockScroll();
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
    }

    if (openBtn) openBtn.addEventListener("click", open);
    closeEls.forEach((el) => el.addEventListener("click", close));

    drawer.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        e.preventDefault();
        close();
      }
    });

    drawer.addEventListener("click", async (e) => {
      // 0) Couleur
      const colorLink = e.target.closest("[data-btl-color]");
      if (colorLink) {
        e.preventDefault();
        const handle = colorLink.getAttribute("data-product-handle");
        const item = colorLink.closest("[data-btl-item]");
        if (!handle || !item) return;

        colorLink.classList.add("is-loading");

        try {
          const productJson = await fetchProductJson(handle);
          updateItemBasics(item, productJson, handle, drawer);
          setSelectedSwatch(colorLink);
        } catch (err) {
          console.error(err);
          window.location.href = colorLink.getAttribute("href");
        } finally {
          colorLink.classList.remove("is-loading");
        }
        return;
      }

      // 1) Taille
      const sizeBtn = e.target.closest("[data-btl-size]");
      if (sizeBtn) {
        const item = sizeBtn.closest("[data-btl-item]");
        if (!item) return;

        const hidden = qs(item, "[data-btl-variant-select]");
        const variantId = Number(sizeBtn.getAttribute("data-variant-id"));

        qsa(item, "[data-btl-size]").forEach((btn) => btn.classList.remove("is-selected"));
        sizeBtn.classList.add("is-selected");

        if (hidden) hidden.value = String(variantId);

        await refreshSubmitFromCurrentSelection(item);
        await refreshLookButton(drawer);
        return;
      }

      // 2) Ajouter un produit
      const addOneBtn = e.target.closest("[data-btl-add-one]");
      if (addOneBtn) {
        const item = addOneBtn.closest("[data-btl-item]");
        const hidden = item ? qs(item, "[data-btl-variant-select]") : null;
        if (!hidden || !hidden.value) return;

        const variantId = Number(hidden.value);

        const selectedBtn = item.querySelector(`[data-btl-size][data-variant-id="${variantId}"]`);
        if (selectedBtn && selectedBtn.hasAttribute("disabled")) {
          await refreshSubmitFromCurrentSelection(item);
          await refreshLookButton(drawer);
          return;
        }

        addOneBtn.disabled = true;
        addOneBtn.setAttribute("aria-busy", "true");

        try {
          const cart = await addItems([{ id: variantId, quantity: 1 }]);

          const labelInCart =
            addOneBtn.getAttribute("data-label-incart") || addOneBtn.dataset.labelIncart;

          if (labelInCart) addOneBtn.textContent = labelInCart;

          addOneBtn.classList.remove("not-in-cart");
          addOneBtn.classList.add("in-cart");

          await refreshCartUI(cart);

          await refreshSubmitFromCurrentSelection(item);
          await refreshLookButton(drawer);
        } catch (err) {
          console.error(err);
          await refreshSubmitFromCurrentSelection(item);
          await refreshLookButton(drawer);
        } finally {
          addOneBtn.removeAttribute("aria-busy");
          addOneBtn.disabled = false;
        }
        return;
      }

      // 3) Ajouter le look
      const addAllBtn = e.target.closest("[data-btl-add-all]");
      if (addAllBtn) {
        const hiddenInputs = qsa(drawer, "[data-btl-item] [data-btl-variant-select]");
        const items = hiddenInputs
          .map((inp) => ({ id: Number(inp.value), quantity: 1 }))
          .filter((x) => Number.isFinite(x.id) && x.id > 0);

        if (!items.length) return;

        addAllBtn.disabled = true;
        addAllBtn.setAttribute("aria-busy", "true");

        try {
          const cart = await addItems(items);

          const btlItems = qsa(drawer, "[data-btl-item]");
          for (const it of btlItems) {
            await refreshSubmitFromCurrentSelection(it);
          }

          const labelInCart =
            addAllBtn.getAttribute("data-label-incart") || addAllBtn.dataset.labelIncart;

          if (labelInCart) addAllBtn.textContent = labelInCart;

          addAllBtn.classList.remove("not-in-cart");
          addAllBtn.classList.add("in-cart");

          await refreshCartUI(cart);
          await refreshLookButton(drawer);
        } catch (err) {
          console.error(err);
          await refreshLookButton(drawer);
        } finally {
          addAllBtn.removeAttribute("aria-busy");
          addAllBtn.disabled = false;
        }
        return;
      }
    });
  }

  function initAllBTLDrawers() {
    document.querySelectorAll('[id^="btl-drawer-"]').forEach(initBTLDrawer);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllBTLDrawers);
  } else {
    initAllBTLDrawers();
  }

  document.addEventListener("shopify:section:load", initAllBTLDrawers);

  // refresh global si d'autres scripts déclenchent cart:updated
  document.addEventListener("cart:updated", async (e) => {
    const cart = e && e.detail && e.detail.cart ? e.detail.cart : await fetchCartCached();
    await refreshCartUI(cart);
  });
})();

(function () {
  const BODY_CLASS = "dropdown-open";

  function syncBodyClass() {
    const dropdownOpen = !!document.querySelector(".dropdown.is-open");
    const productOptionOpen = !!document.querySelector(".product__option.is-open");

    document.body.classList.toggle(BODY_CLASS, dropdownOpen || productOptionOpen);
  }

  // état initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncBodyClass);
  } else {
    syncBodyClass();
  }

  // observe les changements de classe (ouverture/fermeture)
  const observer = new MutationObserver(syncBodyClass);
  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });
})();

// ===== iOS scroll killer fix: neutralize global touchmove preventDefault when nothing is open =====
(function () {
  function isQuickCartOpen() {
    const w = document.querySelector(".quick-cart .quick-cart__wrapper");
    return !!(w && w.classList.contains("active"));
  }

  function isBTLOpen() {
    return !!document.querySelector('[id^="btl-drawer-"][aria-hidden="false"]');
  }

  function isNotifyOpen() {
    const w = document.querySelector(".restock-alerts-modal-wrapper");
    if (!w) return false;
    const st = getComputedStyle(w);
    // “open” if displayed/visible and can receive events
    return st.display !== "none" && st.visibility !== "hidden" && st.opacity !== "0";
  }

  function isAnyThemeDropdownOpen() {
    // tu as déjà une logique dropdown-open, on s’en sert
    return document.body.classList.contains("dropdown-open");
  }

  function isFilterDrawerOpen() {
  return !!document.querySelector(
    '.filter-group--active, .filter-group__values[aria-hidden="false"]'
  );
}

function shouldAllowPageScroll() {
  if (isQuickCartOpen()) return false;
  if (isBTLOpen()) return false;
  if (isNotifyOpen()) return false;
  if (isAnyThemeDropdownOpen()) return false;
  if (isFilterDrawerOpen()) return false;
  if (document.body.classList.contains('zoom-open')) return false;
  return true;
}


  // Capture-phase: runs before other listeners.
  // If we stop propagation here, other scripts cannot preventDefault -> scroll works again on iOS.
  document.addEventListener(
    "touchmove",
    function (e) {
      if (!shouldAllowPageScroll()) return;

      // If gesture started inside a horizontally scrollable area (slider), let it behave.
      const t = e.target;
      const scroller = t && t.closest && t.closest("[data-btl-track], .btl-slider__track, .swiper-wrapper");
      if (scroller) return;

      // Prevent other listeners from killing scroll
      e.stopImmediatePropagation();
      // DO NOT call preventDefault()
    },
    { capture: true, passive: false }
  );
})();

(function () {
  const bar = document.querySelector(".sticky-atc-bar");
  if (!bar) return;

  const HIDE = "ao-hide-sticky-atc-top";
  const bp = 989;
  const threshold = 40; // px depuis le haut

  const style = document.createElement("style");
  style.textContent = `@media (max-width:${bp}px){ .sticky-atc-bar.${HIDE}{display:none !important;} }`;
  document.head.appendChild(style);

  function isMobile(){ return window.matchMedia(`(max-width:${bp}px)`).matches; }

  function onScroll(){
    if (!isMobile()) { bar.classList.remove(HIDE); return; }
    bar.classList.toggle(HIDE, window.scrollY <= threshold);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();
})();

/* ============================================================
   CART ITEM EDITOR — Modifier variante depuis le panier
   ============================================================ */
(function () {
  'use strict';

  function $1(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
    var cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection) return;
    var sectionId = cartSection.dataset.sectionId;
    var base = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base) || '/cart';
    fetch(base + '?section_id=' + sectionId)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var dom = new DOMParser().parseFromString(html, 'text/html');
        var targetItems    = cartSection.querySelector('[js-cart-items]');
        var sourceItems    = dom.querySelector('[js-cart-items]');
        var targetSubtotal = cartSection.querySelector('[js-cart-footer-subtotal-wrapper]');
        var sourceSubtotal = dom.querySelector('[js-cart-footer-subtotal-wrapper]');
        if (targetItems && sourceItems)       targetItems.innerHTML = sourceItems.innerHTML;
        if (targetSubtotal && sourceSubtotal) targetSubtotal.outerHTML = sourceSubtotal.outerHTML;
      })
      .catch(function(err) { console.error('[CartEditor] refreshCart:', err); });
  }

  function cartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r) { return r.json(); });
  }

  function cartAdd(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    }).then(function(r) { return r.json(); });
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function(v) {
      return selectedOptions.every(function(val, i) {
        return v['option' + (i + 1)] === val;
      });
    });
  }

  // ── Initialise un editor ──────────────────────────────────
  function initEditor(editor) {
    if (editor._ready) return;
    editor._ready = true;

    // ⚡ Lecture du JSON depuis <script type="application/json">
    // au lieu du data-attribute pour éviter les problèmes d'échappement
    var variantsEl = $1('[data-cart-editor-variants]', editor);
    var variants = [];
    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch(e) {
        console.error('[CartEditor] Erreur parsing variants:', e);
      }
    }

    var currentVariantId = parseInt(editor.dataset.currentVariantId, 10);
    var itemKey          = editor.dataset.itemKey;
    var itemLine         = parseInt(editor.dataset.itemLine, 10);

    var optionGroups = $$('[data-option-group]:not([data-sibling-color-group])', editor);
    var numOptions   = optionGroups.length;

    // Initialise selectedOptions depuis la variante courante
    var selectedOptions = new Array(numOptions);
    var currentVariant  = variants.find(function(v) { return v.id === currentVariantId; });
    if (currentVariant) {
      for (var i = 0; i < numOptions; i++) {
        selectedOptions[i] = currentVariant['option' + (i + 1)];
      }
    }

    var selectedSiblingHandle = null;
    var errorEl  = $1('[data-editor-error]', editor);
    var actions = document.querySelector('[data-cart-item-actions][data-item-key="' + itemKey + '"]');

    var saveBtn  = actions ? $1('[data-save-item]', actions) : null;
    var cancelBtn = actions ? $1('[data-cancel-edit]', actions) : null;
    function clearError() { if (errorEl) errorEl.textContent = ''; }
    function showError(msg) { if (errorEl) errorEl.textContent = msg; }

    // ── Sync UI ──────────────────────────────────────────────
    function syncOptionUI() {
      optionGroups.forEach(function(group, idx) {
        var val = selectedOptions[idx];

        // Label
        var label = $1('[data-selected-label]', group);
        if (label) label.textContent = val;

        // Boutons chip/swatch
        $$('[data-option-buttons] [data-option-value]', group).forEach(function(btn) {
          var isSel = btn.dataset.optionValue === val;
          btn.classList.toggle('selected', isSel);
          btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        });

        // Select natif
        var sel = $1('[data-option-select]', group);
        if (sel) sel.value = val;
      });

      updateChipAvailability();
    }

    // Recalcule la dispo côté JS (pour quand l'user change d'option)
    function updateChipAvailability() {
      optionGroups.forEach(function(group, groupIdx) {
        $$('[data-option-value]', group).forEach(function(btn) {
          var testVal = btn.dataset.optionValue;
          var available = variants.some(function(v) {
            if (!v.available) return false;
            for (var i = 0; i < numOptions; i++) {
              var expected = (i === groupIdx) ? testVal : selectedOptions[i];
              if (v['option' + (i + 1)] !== expected) return false;
            }
            return true;
          });
          var isSelected = btn.classList.contains('selected');
          btn.classList.toggle('is-disabled', !available && !isSelected);
          if (btn.tagName === 'BUTTON') {
            btn.setAttribute('aria-disabled', (!available && !isSelected) ? 'true' : 'false');
          }
        });
      });
    }

    // ── Clics options taille/coupe ───────────────────────────
    $$('[data-option-buttons]', editor).forEach(function(container) {
      if (container.closest('[data-sibling-color-group]')) return;
      container.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-option-value]');
        if (!btn) return;
        var group    = btn.closest('[data-option-group]');
        var groupIdx = optionGroups.indexOf(group);
        if (groupIdx === -1) return;
        selectedOptions[groupIdx] = btn.dataset.optionValue;
        syncOptionUI();
        clearError();
      });
    });

    $$('[data-option-select]', editor).forEach(function(sel) {
      sel.addEventListener('change', function() {
        var group    = sel.closest('[data-option-group]');
        var groupIdx = optionGroups.indexOf(group);
        if (groupIdx === -1) return;
        selectedOptions[groupIdx] = sel.value;
        syncOptionUI();
        clearError();
      });
    });

    // ── Clics siblings couleur ───────────────────────────────
    var siblingGroup = $1('[data-sibling-color-group]', editor);
    if (siblingGroup) {
      var siblingBtnsContainer = $1('[data-sibling-buttons]', siblingGroup);
      var siblingNoteEl   = $1('[data-sibling-note]', siblingGroup);
      var siblingLabelEl  = $1('[data-sibling-selected-label]', siblingGroup);

      if (siblingBtnsContainer) {
        siblingBtnsContainer.addEventListener('click', function(e) {
          var btn = e.target.closest('[data-sibling-handle]');
          if (!btn) return;

          $$('[data-sibling-handle]', siblingGroup).forEach(function(b) {
            var isSel = b === btn;
            b.classList.toggle('selected', isSel);
            b.setAttribute('aria-pressed', isSel ? 'true' : 'false');
          });

          selectedSiblingHandle = btn.dataset.siblingHandle;
          var color = btn.dataset.siblingColor || '';
          if (siblingLabelEl) siblingLabelEl.textContent = color.charAt(0).toUpperCase() + color.slice(1);
          if (siblingNoteEl)  siblingNoteEl.textContent  = '';
          clearError();
        });
      }
    }

    // ── Enregistrer ──────────────────────────────────────────
    if (saveBtn) {
      saveBtn.dataset.origText = saveBtn.textContent.trim();

      saveBtn.addEventListener('click', function() {
        var itemEl   = editor.closest('[data-input-item]');
        var qtyInput = $1('[data-quantity-input]', itemEl);
        var qty      = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

        function setSaving(on) {
          saveBtn.disabled = on;
          saveBtn.textContent = on ? savingText : saveBtn.dataset.origText;
        }

        // Fonction commune : add nouvelle variante, supprime l'ancienne par key, ferme
        function saveVariant(newVariantId) {
          setSaving(true);
          // 1. Add la nouvelle variante
          cartAdd(newVariantId, qty)
            .then(function() {
              // 2. Supprimer l'ancienne par sa key (résistant aux décalages de ligne)
              return cartChange({ id: itemKey, quantity: 0 });
            })
            .then(function() {
              // 3. Fermer l'éditeur AVANT le re-render (le re-render détruit le DOM)
              closeEditor(editor);
              // 4. Rafraîchir le cart
              refreshCart();
            })
            .catch(function(err) {
              console.error('[CartEditor]', err);
              showError('Une erreur est survenue.');
              setSaving(false);
            });
        }

        if (selectedSiblingHandle) {
          // Changement de couleur = changement de produit sibling
          setSaving(true);
          fetch('/products/' + selectedSiblingHandle + '.js')
            .then(function(r) { return r.json(); })
            .then(function(siblingProduct) {
              var sibVariants = siblingProduct.variants;
              var target = findVariant(sibVariants, selectedOptions)
                        || sibVariants.find(function(v) { return v.available; })
                        || sibVariants[0];
              if (!target) { showError('Variante introuvable.'); setSaving(false); return; }
              saveVariant(target.id);
            })
            .catch(function(err) {
              console.error('[CartEditor sibling]', err);
              showError('Une erreur est survenue.');
              setSaving(false);
            });

        } else {
          // Changement de taille/option sur le même produit
          var target = findVariant(variants, selectedOptions);
          if (!target) { showError('Cette combinaison n\'est pas disponible.'); return; }
          if (target.id === currentVariantId) { closeEditor(editor); return; }
          if (!target.available) { showError('Cette variante est en rupture de stock.'); return; }

          saveVariant(target.id);
        }
      });
    }

    // ── Annuler ──────────────────────────────────────────────
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function() { closeEditor(editor); });
    }

    // Intercepter les clics +/- de l'editeur AVANT que QuantityButtons
    // (theme.js Delegate) ne les recoive et appelle cart.updateItem().
    // stopPropagation en capture empeche la remontee vers la Delegate.
    editor.addEventListener('click', function(e) {
      var plusBtn  = e.target.closest('[data-add-quantity]');
      var minusBtn = e.target.closest('[data-subtract-quantity]');
      if (!plusBtn && !minusBtn) return;
      e.stopPropagation();
      var qtyInput = $1('[data-quantity-input]', editor);
      if (!qtyInput) return;
      var current = parseInt(qtyInput.value, 10) || 1;
      var next = plusBtn ? current + 1 : Math.max(1, current - 1);
      qtyInput.value = String(next);
    }, true);

    syncOptionUI();
  }

  // ── Ouvre l'editor ───────────────────────────────────────
  function openEditor(itemEl) {
    var displayEl  = $1('[data-variant-display]', itemEl);
    var displayTitle  = $1('[data-title-display]', itemEl);

    var editor     = $1('[data-cart-item-editor]', itemEl);
    var modifyBtn  = $1('[data-modify-item]', itemEl);
    var removeWrap = itemEl && itemEl.querySelector('.cart__form-item-quantity-wrapper');
    var infoWrap = itemEl && itemEl.querySelector('.cart__form-item-info');
    if (!editor) return;

    var itemKey = editor.dataset.itemKey;
    var actions = document.querySelector('[data-cart-item-actions][data-item-key="' + itemKey + '"]');

    initEditor(editor);

    if (displayEl)  displayEl.setAttribute('aria-hidden', 'true');
    if (displayTitle)  displayTitle.setAttribute('aria-hidden', 'true');
    editor.setAttribute('aria-hidden', 'false');
    if (modifyBtn)  modifyBtn.setAttribute('aria-hidden', 'true');
    if (removeWrap) removeWrap.setAttribute('aria-hidden', 'true');
    if (actions)    actions.removeAttribute('aria-hidden');
    if (infoWrap) infoWrap.setAttribute('aria-hidden', 'true');
  }

  // ── Ferme l'editor ───────────────────────────────────────
function closeEditor(editor) {
  var itemEl     = editor.closest('[data-input-item]');
  var displayEl  = $1('[data-variant-display]', itemEl);
  var displayTitle  = $1('[data-title-display]', itemEl);
  var modifyBtn  = $1('[data-modify-item]', itemEl);
  var removeWrap = itemEl && itemEl.querySelector('.cart__form-item-quantity-wrapper');
  var infoWrap = itemEl && itemEl.querySelector('.cart__form-item-info');

  var itemKey = editor.dataset.itemKey;
  var actions = document.querySelector('[data-cart-item-actions][data-item-key="' + itemKey + '"]');

  editor.setAttribute('aria-hidden', 'true');
  if (displayEl)  displayEl.removeAttribute('aria-hidden');
  if (displayTitle)  displayTitle.removeAttribute('aria-hidden');
  if (modifyBtn)  modifyBtn.removeAttribute('aria-hidden');
  if (removeWrap) removeWrap.removeAttribute('aria-hidden');
  if (actions)    actions.setAttribute('aria-hidden', 'true');
  if (infoWrap) infoWrap.removeAttribute('aria-hidden');

  var errorEl = $1('[data-editor-error]', editor);
  if (errorEl) errorEl.textContent = '';
}
  // ── Délégation globale ───────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-modify-item]');
    if (btn) {
      var itemEl = btn.closest('[data-input-item]');
      if (itemEl) openEditor(itemEl);
    }
  });

})();